import React from 'react';
import { StarIcon, DownloadIcon, ArrowRightIcon } from 'lucide-react';
const GUIDE_URL = 'https://drive.google.com/file/d/1_VMeI7UFSxbtdMmJFL6PqeFIiuh-GLOi/view?usp=sharing';
export function ThankYouHandbookPage() {
  return <main className="min-h-screen w-full bg-[#f8f7f4] text-[#1e293b] font-sans selection:bg-[#b91c1c] selection:text-white flex flex-col items-center justify-start p-4 sm:p-8 relative overflow-hidden" data-id="element-1555">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-1556"></div>

      {/* Subtle Gradient Glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-[#dbeafe] opacity-40 blur-[120px] rounded-full pointer-events-none" data-id="element-1557"></div>
      <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-[#fecaca] opacity-20 blur-[100px] rounded-full pointer-events-none" data-id="element-1558"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto space-y-8 py-8 sm:py-12" style={{
      marginLeft: '0px',
      marginRight: '0px'
    }} data-id="element-1559">
        {/* Header */}
        <div className="space-y-4" data-id="element-1560">
          <p className="text-lg italic text-[#475569] leading-relaxed px-6 sm:px-8" data-id="element-1561">
            Thank you for requesting{' '}
            <span className="font-semibold text-[#0f172a] not-italic" data-id="element-1562">
              "The 72-Hour Survival Handbook"
            </span>
            . You can download it by clicking the link below…
          </p>
        </div>

        {/* Content Section */}
        <div className="overflow-hidden" data-id="element-1563">
          <div className="space-y-8" data-id="element-1564">
            {/* Content Card */}
            <div className="" data-id="element-1565">
              <div className="p-6 sm:p-8 space-y-8" data-id="element-1566">
                {/* Section 1: Download */}
                <section className="space-y-4" data-id="element-1567">
                  <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-[#0f172a]" data-id="element-1568">
                    Step #1: Download Your{' '}
                    <span className="text-[#b91c1c]" data-id="element-1569">FREE</span> Handbook
                  </h2>

                  <a href={GUIDE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#002868] font-semibold text-lg underline underline-offset-4 decoration-[#002868]/40 hover:decoration-[#002868] transition-all" style={{
                  fontWeight: '700',
                  color: '#0000EE'
                }} data-id="element-1570">
                    <DownloadIcon className="w-5 h-5 flex-shrink-0" data-id="element-1571" />
                    The 72-Hour SurvivalHandbook (click to
                    download)
                  </a>
                </section>

                {/* Divider */}
                <div className="border-t border-[#e2e8f0]" data-id="element-1572"></div>

                {/* Section 2: Next Step */}
                <section className="space-y-4" data-id="element-1573">
                  <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-[#0f172a]" data-id="element-1574">
                    Step #2: Discover How to Create{' '}
                    <span className="text-[#b91c1c]" data-id="element-1575">
                      An On-Demand Water Supply For Your Family
                    </span>{' '}
                    (4 easy steps)
                  </h2>

                  <a href="https://hop.clickbank.net/?affiliate=lourdn&vendor=watersb&tid=TRACKINGID&pid=6" className="inline-flex items-center gap-2 text-[#002868] font-semibold text-lg underline underline-offset-4 decoration-[#002868]/40 hover:decoration-[#002868] transition-all" style={{
                  fontWeight: '700',
                  color: '#0000EE'
                }} data-id="element-1576">
                    <ArrowRightIcon className="w-5 h-5 flex-shrink-0" data-id="element-1577" />
                    Click Here to Learn How to Secure Your Water Supply for Life
                  </a>
                </section>
              </div>

              {/* Red, White, Blue stripe */}
              <div className="h-2 w-full flex" style={{
              marginTop: '100px'
            }} data-id="element-1578">
                <div className="flex-1 bg-[#b91c1c]" data-id="element-1579"></div>
                <div className="flex-1 bg-[#f8f7f4]" data-id="element-1580"></div>
                <div className="flex-1 bg-[#1b2a4a]" data-id="element-1581"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="text-center text-[#94a3b8] text-xs" data-id="element-1582">
          <p data-id="element-1583">© 2026 PatriotsInformer. All rights reserved.</p>
        </footer>
      </div>
    </main>;
}